'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 * @param {String} className Additional class to be applied to loader element
 */
var show = function (container, className) {
	var target = (!container || $(container).length === 0) ? $('body') : $(container);
	$loader = $loader || $('.loader');
	var loaderClass = ['loader'];
	if (className) {
		loaderClass.push(className);
	}

	if ($loader.length === 0) {
		$loader = $('<div/>').addClass(loaderClass.join(' '))
			.append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
	}
	return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function () {
	if ($loader) {
		$loader.hide();
	}
};

exports.show = show;
exports.hide = hide;
